import {
    getCreateconsignmentAddApiEndpoint,
    getDetailedconsignmentAddProductTemplatesEndpoint,
    getconsignmentAddCategoryAndBrandsApiEndpoint,
    getconsignmentAddProductsByBrandOrSuperCategoryApiEndpoint,
    getProductDetailsApiEndpoint,
    getconsignmentAddProductSearchEndpoint,
    getValidatedProductsEndpoint,
    getconsignmentAddTemplateDetailsEndpoint,
    createconsignmentAddProductTemplateEndpoint,
    updateconsignmentAddProductTemplateEndpoint,
    getDataForconsignmentAddTemplateEndpoint,
    getPricesForItemsEndpoint,
} from 'src/pages/consignmentAdd/services/endpoints';
import {} from 'src/pages/consignmentAdd/services/endpoints';
import axios from 'src/api/Api';
import { getDropdownEnpoint } from './endpoints';
export const saveconsignmentAddDataService = async (obj) => {
    try {
        const response = await axios.post(getCreateconsignmentAddApiEndpoint, obj);
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getconsignmentAddCategoryAndBrandsDataService = async (territoryIdValue) => {
    try {
        const response = await axios.get(getconsignmentAddCategoryAndBrandsApiEndpoint(territoryIdValue));
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getconsignmentAddProductsByBrandOrSuperCategoryDataService = async (
    queryParams
) => {
    try {
        const response = await axios.get(
            getconsignmentAddProductsByBrandOrSuperCategoryApiEndpoint(queryParams)
        );
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getProductsGuideDataService = async () => {
    try {
        const response = await axios.get('productsGuide');
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getProductDetailsDataService = async (
    productCFN,
    salesOrg,
    orderType,
    resourceType
) => {
    try {
        const response = await axios.get(
            getProductDetailsApiEndpoint(
                productCFN,
                salesOrg,
                orderType,
                resourceType
            )
        );
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getconsignmentAddProductSearchDataService = async (queryParams, token) => {
    try {
        const response = await axios.get(
            getconsignmentAddProductSearchEndpoint(queryParams),
            { cancelToken: token }
        );
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getDetailedconsignmentAddProductTemplatesDataService = async (
    queryParams
) => {
    try {
        const response = await axios.get(
            getDetailedconsignmentAddProductTemplatesEndpoint(queryParams)
        );
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getconsignmentAddValidateProductsDataServices = async (queryParams) => {
    try {
        const response = await axios.get(
            getValidatedProductsEndpoint(queryParams)
        );
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getPricesForItemsDataService = async (queryParams) => {
    try {
        const response = await axios.get(
            getPricesForItemsEndpoint(queryParams)
        );
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};
export const getconsignmentAddTemplateDetailsDataService = async (queryParams) => {
    try {
        const response = await axios.get(
            getconsignmentAddTemplateDetailsEndpoint(queryParams)
        );
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const createconsignmentAddProductTemplateDataService = async (queryParams) => {
    try {
        const response = await axios.post(
            createconsignmentAddProductTemplateEndpoint,
            queryParams
        );
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const updateconsignmentAddProductTemplateDataService = async (queryParams) => {
    try {
        const response = await axios.put(
            updateconsignmentAddProductTemplateEndpoint,
            queryParams
        );
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getDataForconsignmentAddTemplateDataService = async (myCaseRef, orderType) => {
    try {
        const response = await axios.get(
            getDataForconsignmentAddTemplateEndpoint(myCaseRef, orderType)
        );
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getProductsTemplatesFilterDataService = async () => {
    try {
        const response = await axios.get('productsTemplatesFilter');
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getDropdownOptionsFunc = async (dropdownType) => {
    try {
        const dropdownEndpoint = getDropdownEnpoint(dropdownType);
        const response = await axios.get(dropdownEndpoint);
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};
